export const SQUARE_BOOKING_URL =
  'https://book.squareup.com/appointments/5r4c1vrtw6oy03/location/LRN8SSDGVPZM9/services'

export const SQUARE_PAYMENT_URL = 'https://square.link/u/LpXv1Mpe'

export const WHATSAPP_NUMBER = '13478886047'
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`
export const PHONE_TEL = '+13472422967'

export const BRIDAL_IMAGES = {
  makeup: 'https://cdn.magicpatterns.com/uploads/qqnqE5DUJGBHiDYRPNyATx/BRIDAL_2.png',
  updo: 'https://cdn.magicpatterns.com/uploads/oWUXjD7cUse2TSspNASpZu/BRIDAL_3.png',
}

export const SERVICE_IMAGES = {
  spaBody: 'https://cdn.magicpatterns.com/uploads/3a8mdzoZKJJqoPAaSyYn8w/SPA_SLIMMING_BODY.png',
  maquillaje: 'https://cdn.magicpatterns.com/uploads/rqDj2bcWDT1fLgS5nQJPGq/MAQUILLAJE2.png',
  limpiezaFacial:
    'https://cdn.magicpatterns.com/uploads/4u9dtBRN5cF9z5V2qxXUns/FACIALES_LIMPIEZA_FACIAL.png',
  cejas: 'https://cdn.magicpatterns.com/uploads/d2V7QiKmcWJCJXRiHzT5Ln/CEJAS_PERFECTAS.png',
  pestanas: 'https://cdn.magicpatterns.com/uploads/43VtYRFrAQi4yjKcYPRdFV/LIFTING_DE_PESTANAS.png',
  masajesSpa: 'https://cdn.magicpatterns.com/uploads/tgdGVkHofmHEJsYyNG1LAW/MASAJES_SPA.png',
  botoxCapilar: 'https://cdn.magicpatterns.com/uploads/vdLDP2WBNKixGdwCaLNN3b/BOTOX_CAPILAR.png',
  keraBotox: 'https://cdn.magicpatterns.com/uploads/wX7xqs4BqCwHABfax8uLYQ/KERA_BOTOX.png',
  spaCapilar: 'https://cdn.magicpatterns.com/uploads/2S5kPYj7pwdinEjNTZcJbS/SPA_CAPILAR.png',
  sombreadoCejas:
    'https://cdn.magicpatterns.com/uploads/7GYrXxviZ2YQ2krKjBoTT8/SOMREADO_DE_CEJAS.png',
  kTipExtension:
    'https://cdn.magicpatterns.com/uploads/bLmhgnU69c3AdAUHWiS5TG/K_TIP_EXTENSION.png',
  colorCompleto: 'https://cdn.magicpatterns.com/uploads/xB6v5W3WXBjdgZsP1uVtXb/COLOR_CPMLETO.png',
  sombreadoCejas2:
    'https://cdn.magicpatterns.com/uploads/wiEyBoqXwmGE1GHvPytWgx/SOMBREADO_DE_CEJAS.png',
  highlights: 'https://cdn.magicpatterns.com/uploads/rLSyHuzPCEU13f7Rmof7Ru/HIGHLIGHTS.png',
  keratina: 'https://cdn.magicpatterns.com/uploads/ad1pPVBsQwh51PXnUiwJij/KERATINA_2.png',
  alisadoGinger:
    'https://cdn.magicpatterns.com/uploads/crDKD1h3iiTkBLfAJmTcrw/ALISADO_GINGER.png',
  alisadoJapones:
    'https://cdn.magicpatterns.com/uploads/uzAzAN82odNiFns6PdGRUk/ALISADO_JAPONES.png',
  colorCompleto2: 'https://cdn.magicpatterns.com/uploads/chU41e6qUEH4RzdhPqXQxF/COLOR_CPMLETO.png',
  balayage: 'https://cdn.magicpatterns.com/uploads/mfNGtCg34hyCKBSyzkgvxh/BALAYAGE_GINGER.png',
  retoqueRaiz: 'https://cdn.magicpatterns.com/uploads/crH1xe2Dv7fbkYxPuEjyNS/RETOQUE_DE_RAIZ.png',
  peinado: 'https://cdn.magicpatterns.com/uploads/bw6nFFADJo4tFa4bHD9QnQ/PEINADO_2.png',
  corteDama: 'https://cdn.magicpatterns.com/uploads/2xirDeMzacfvFCzgUXowwL/CORTE_PARA_DAMA.png',
  blowout: 'https://cdn.magicpatterns.com/uploads/i4xgnaBma1jgWFRWwAypUg/BLOWOUT.png',
  maquillajeGlowUp:
    'https://cdn.magicpatterns.com/uploads/2tK8vnrEJNeLxbpa44unTF/MAQUILLAJE_GLOW_UP.png',
  maquillajeFullFace:
    'https://cdn.magicpatterns.com/uploads/jWeQvXY982xsfSGJiLt1B5/MAQUILLAJE_FULL_FACE.png',
  asesoriaImagen:
    'https://cdn.magicpatterns.com/uploads/9SLHTvNMv3NMGfhH8Lky5k/ASESORIA_DE_IAMGEN.png',
  maquillajeSocial:
    'https://cdn.magicpatterns.com/uploads/ra4R43dsn9LYdbJqBgEpMF/MAQUILLAJE_SOCIAL.png',
  repolarizacion:
    'https://cdn.magicpatterns.com/uploads/4tBTijicFHRZ8rcJaL5DtL/REPOLARIZACION_ANTIFRIZZ.png',
  liftingCapilar:
    'https://cdn.magicpatterns.com/uploads/d21DEmtVopSgU4eS5fWG5t/LIFTING_CAPILAR.png',
  cocktailCapilar:
    'https://cdn.magicpatterns.com/uploads/cSwoqPPQZXVY8mZtn4QjfJ/COCKTAIL_CAPILAR.png',
  nanoplastia: 'https://cdn.magicpatterns.com/uploads/oqt2TwbEQ7VSCLyhJizn7b/NANOPLASTIA.png',
  deepConditioning:
    'https://cdn.magicpatterns.com/uploads/2NS1buHF9JEmz3pGzqckLh/DEEP_CONDITIONING_TREATMENT.png',
  cirugiaCapilar:
    'https://cdn.magicpatterns.com/uploads/pqprTLMpv24wPvfrYKcgNw/cirugia_capilar.png',
  keraplastia: 'https://cdn.magicpatterns.com/uploads/hszzTr2SKH7kwAEfQ3wtDj/keraplastia.png',
  tratamientoBambu:
    'https://cdn.magicpatterns.com/uploads/uYnGtHVUc52barvUpqtfSr/Tratamiento_bambu.png',
  moneyPieceFullFace:
    'https://cdn.magicpatterns.com/uploads/wzLYYcdXtG8usBohU3b3sN/MONEY_PIECE_FULL_FACE.png',
  spaAlivioExpress:
    'https://cdn.magicpatterns.com/uploads/aKkiJWziScsz94TW44rMW5/spa_alivio_express.png',
  extensionHandTied:
    'https://cdn.magicpatterns.com/uploads/mWXjq86eXPfgDTFUH55wvj/extension_hand_tied.png',
  extensionIndividual:
    'https://cdn.magicpatterns.com/uploads/9pcQhCqMX93KMxzddZPmLH/extension_individual2.png',
}

export const ACADEMY_COURSE_MEDIA = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/2nddq5GepbtM8Ru839SeBV/MAQUILLAJE_CURSO.png',
    insetImage: 'https://cdn.magicpatterns.com/uploads/vXkQteYKEdrqZuCvk9pLvw/MAQUILLAJE_4.png',
    featured: true,
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/bDLuj8vTRtP5naShsN8nY1/COLOMETRIA.png',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/hjy2N5nyP3qVc6yvpZbaK9/CURSO_ALISADO.png',
  },
]

export const GALLERY_IMAGES = [
  'https://cdn.magicpatterns.com/uploads/5VT1NqhZgqGtjP4aVjGNiM/ginger_5.png',
  'https://cdn.magicpatterns.com/uploads/nhwrtbBJZJMuSQCDdC3UbR/ginger_4.png',
  'https://cdn.magicpatterns.com/uploads/sKZr4sXnX6sG2hMMtrmdgP/ginger_3.png',
  'https://cdn.magicpatterns.com/uploads/sZ19PCHvfo3WXhSaVDEqYv/ginger_2.png',
  'https://cdn.magicpatterns.com/uploads/u6Mj2J8ESKp6kqQNmjqJNN/ginger_1.png',
  'https://cdn.magicpatterns.com/uploads/4PG4st3C5gVkvRZmjmQc9M/ginger_6.png',
  'https://cdn.magicpatterns.com/uploads/wayjZWw6PtQfybgVLnjEmU/GINGER_8.png',
  'https://cdn.magicpatterns.com/uploads/bq2geH8LgHQUvESer2gVM3/GINGER_7.png',
  'https://cdn.magicpatterns.com/uploads/ofHBjwdYYtrcum7VyVjLjX/HIGHLIGHTS.png',
  'https://cdn.magicpatterns.com/uploads/apek3ibJx8YmYE9cne5fGc/COLOR_CPMLETO.png',
  'https://cdn.magicpatterns.com/uploads/2tJ8iBsMHyogGpVqxrPhYj/BALAYAGE_GINGER.png',
  'https://cdn.magicpatterns.com/uploads/3SJTSdSx9SaKGZX2PTMUuW/ALISADO_GINGER.png',
  'https://cdn.magicpatterns.com/uploads/uBc4MVVT2bXgohT62sK1Gp/MAQUILLAJE_FULL_FACE.png',
  'https://cdn.magicpatterns.com/uploads/twiXyvS6NJsTPf3GNjCETw/MAQUILLAJE_GLOW_UP.png',
  'https://cdn.magicpatterns.com/uploads/8KVwx7wnDrfDYkaqrmAa53/MONEY_PIECE_FULL_FACE.png',
]

export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uV1NS9bjWWc4mRwPMPMPo2/LOGO_GINGER.jpg'
export const BANNER_URL = 'https://cdn.magicpatterns.com/uploads/nDPPGGjxzMz4cKwfWuiYid/BANNER_GINGER_1.png'
